import React from 'react'

export default function Svg({drawing,Color}) {
switch(drawing){
    case"CL01":
        return(
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
            <path d="M46.6832,258.673v-217.346h206.63361v217.346h-206.63361Zm78.68547-118.84171v-86.07925h-69.6026v86.07925h69.6026ZM238.2733,245.65363v-139.69206h-63.07755v139.69206h63.07755Z" fill={Color} />
            <text x="115.538809" y="176.478857" fontFamily='Roboto' fill='#ffffff'>CL01</text>
          </svg>
        )
        break;
    case"CL02":
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
        <defs>
          <radialGradient id="fillGradient" cx="0.5" cy="0.5" r="0.5">
            <stop offset="100%" stop-color="#000"/>
            <stop offset="100%" stop-color="#fff"/>
          </radialGradient>
          <linearGradient id="strokeGradient" x1="0" y1="0.5" x2="1" y2="0.5">
            <stop offset="0%" stop-color="#fff"/>
            <stop offset="100%" stop-color="rgba(0,5,5,0)"/>
          </linearGradient>
        </defs>
        <path d="M232.1,16.7v175.6h0v19.7L67.9,238.2v-45.8h0v-175.6h164.2ZM181,132.1v-67.6h-62v67.6h62Z" transform="matrix(1 0 0-1 0 254.87)" fill={Color} />
        <text x="132" y="87" fill="#fff7f7" font-family="Roboto" font-size="15">CL02</text>
      </svg>

    )
    break;
    case"CL03":
    return(
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">  <defs>

  </defs>



  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(338.145732 213.7031)" stroke-width="0">
    <tspan y="0" font-weight="400" stroke-width="0"></tspan>
  </text>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(263.648722 206.634041)" fill="url(#e6K7bhLpl1k4-fill)" stroke="url(#e6K7bhLpl1k4-stroke)">
    <tspan x="0" y="15" font-weight="400"></tspan>
  </text>
  <rect width="46" height="46" rx="0" ry="0" transform="matrix(4.492035 0 0 4.724913 46.683195 41.327001)" fill={Color}/>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(111.15816 164.171671)" fill="#fffcfc" stroke-width="0">
    <tspan y="0" font-weight="400" stroke-width="0">CL03</tspan>
  </text>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(146.193583 178.901578)" stroke-width="0">
    <tspan y="0" font-weight="400" stroke-width="0"></tspan>
  </text>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(88.009788 141.381185)" stroke-width="0">
    <tspan y="0" font-weight="400" stroke-width="0"></tspan>
  </text>
  <rect width="46" height="46" rx="0" ry="0" transform="matrix(1.371251 0 0 3.036784 150 101.79343)" fill="#fff"/>
</svg>



    )
    break;
    case"CL04":
    return(
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
  <defs>
    <radialGradient id="ecm6aA51qYC4-fill" cx="0" cy="0" r="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0.5 0.5)">
      <stop id="ecm6aA51qYC4-fill-0" offset="100%" stop-color="#000"/>
      <stop id="ecm6aA51qYC4-fill-1" offset="100%" stop-color="#fff"/>
    </radialGradient>
    <linearGradient id="ecm6aA51qYC4-stroke" x1="0" y1="0.5" x2="1" y2="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0 0)">
      <stop id="ecm6aA51qYC4-stroke-0" offset="0%" stop-color="#fff"/>
      <stop id="ecm6aA51qYC4-stroke-1" offset="100%" stop-color="rgba(0,5,5,0)"/>
    </linearGradient>
  </defs>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(338.145732 213.7031)" stroke-width="0">
    <tspan y="0" font-weight="400" stroke-width="0"></tspan>
  </text>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(263.648722 206.634041)" fill="url(#ecm6aA51qYC4-fill)" stroke="url(#ecm6aA51qYC4-stroke)">
    <tspan x="0" y="15" font-weight="400"></tspan>
  </text>
  <path d="M124.98638,238.1728v-175.6388h-.00002v-45.84003l47.8522,26.1345v19.70553h-.00017v175.6388h-47.85201Z" transform="matrix(1.795447 0 0 1-117.36443 0)" fill={Color}/>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(132.523531 132.599236)" fill="#fff7f7" stroke-width="0">
    <tspan y="0" font-weight="400" stroke-width="0">CL04</tspan>
  </text>
</svg>


    );
    break;
    case"EL01":
return(
    <svg viewBox="0 0 300 300" shapeRendering="geometricPrecision" textRendering="geometricPrecision" projectId="dfa7c9ec3b0a43d6b9175046a5fd134e" exportId="cb986e87a76043b9b769f2ad4d9724ad" cached="false">
  <defs>
    <radialGradient id="e7pUvLNzgcM4-fill" cx="0" cy="0" r="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0.5 0.5)">
      <stop id="e7pUvLNzgcM4-fill-0" offset="100%" stopColor="#000"/>
      <stop id="e7pUvLNzgcM4-fill-1" offset="100%" stopColor="#fff"/>
    </radialGradient>
    <linearGradient id="e7pUvLNzgcM4-stroke" x1="0" y1="0.5" x2="1" y2="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0 0)">
      <stop id="e7pUvLNzgcM4-stroke-0" offset="0%" stopColor="#fff"/>
      <stop id="e7pUvLNzgcM4-stroke-1" offset="100%" stopColor="rgba(0,5,5,0)"/>
    </linearGradient>
    <linearGradient id="e7pUvLNzgcM7-fill" x1="0" y1="0.5" x2="1" y2="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0 0)">
      <stop id="e7pUvLNzgcM7-fill-0" offset="100%" stopColor="#fff"/>
      <stop id="e7pUvLNzgcM7-fill-1" offset="100%" stopColor="#000"/>
    </linearGradient>
  </defs>
  <text dx="0" dy="0" fontFamily="Roboto" fontSize="15" fontWeight="400" transform="translate(338.145732 213.7031)" strokeWidth="0">
    <tspan y="0" fontWeight="400" strokeWidth="0"></tspan>
  </text>
  <text dx="0" dy="0" fontFamily="Roboto" fontSize="15" fontWeight="400" transform="translate(263.648722 206.634041)" fill="url(#e7pUvLNzgcM4-fill)" stroke="url(#e7pUvLNzgcM4-stroke)">
    <tspan x="0" y="15" fontWeight="400"></tspan>
  </text>
  <path d="M57.09593,244.51542v-189.03084h56.13291v0v0h.55381v.86098l60.18517,93.56595-60.18517,94.78088-.00052-.17698-56.6862.00001Z" fill={Color} transform="translate(54.775159-13.646909)"/>
  <text dx="0" dy="0" fontFamily="Roboto" fontSize="15" fontWeight="400" transform="translate(142.506115 141.718083)" fill="url(#e7pUvLNzgcM7-fill)" strokeWidth="0">
    <tspan y="0" fontWeight="400" strokeWidth="0">EL01</tspan>
  </text>
  <text dx="0" dy="0" fontFamily="Roboto" fontSize="15" fontWeight="400" transform="translate(221.904971 127.060045)" strokeWidth="0">
    <tspan y="0" fontWeight="400" strokeWidth="0"></tspan>
  </text>
</svg>

)
break;
default:
return(
    <svg id="e2s47FiPECe1" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" project-id="dfa7c9ec3b0a43d6b9175046a5fd134e" export-id="b18d4935daab4f6a96479c7c69a096a8" cached="false">
  <defs>
    <radialGradient id="e2s47FiPECe3-fill" cx="0" cy="0" r="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0.5 0.5)">
      <stop id="e2s47FiPECe3-fill-0" offset="0%" stop-color="#000"/>
      <stop id="e2s47FiPECe3-fill-1" offset="0%" stop-color="#fff"/>
    </radialGradient>
  </defs>
  <rect width="48" height="48" rx="0" ry="0" transform="matrix(3.239986 0 0 3.893641 72.240336 65.252997)" fill={Color}/>
  <text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(130.662045 163.866231)" fill="url(#e2s47FiPECe3-fill)" stroke-width="0">
    <tspan y="0" font-weight="400" stroke-width="0">
      EW01
    </tspan>
  </text>
</svg>

)
break;
case "EW02":
return(<svg id="eKjTk8iYytS1" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" project-id="dfa7c9ec3b0a43d6b9175046a5fd134e" export-id="ca955f6fdb9f4b9fa40f72a7f0b6a75f" cached="false">
<defs>
  <radialGradient id="eKjTk8iYytS14-fill" cx="0" cy="0" r="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0.5 0.5)">
    <stop id="eKjTk8iYytS14-fill-0" offset="100%" stop-color="#000"/>
    <stop id="eKjTk8iYytS14-fill-1" offset="100%" stop-color="#fff"/>
  </radialGradient>
  <linearGradient id="eKjTk8iYytS14-stroke" x1="0" y1="0.5" x2="1" y2="0.5" spreadMethod="pad" gradientUnits="objectBoundingBox" gradientTransform="translate(0 0)">
    <stop id="eKjTk8iYytS14-stroke-0" offset="0%" stop-color="#fff"/>
    <stop id="eKjTk8iYytS14-stroke-1" offset="100%" stop-color="rgba(0,5,5,0)"/>
  </linearGradient>
</defs>
<path d="M72.24034,252.14777v-186.89477h155.51933v186.89477h-155.51933Z" transform="matrix(1.125874 0 0 1.151296-18.881106-25.09828)" fill={Color}/>
<rect width="46" height="46" rx="0" ry="0" transform="matrix(1.158473 0 0 1.422087 169.032119 71.615)" fill="#fff7f7" stroke="#fff"/>
<text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(126.073953 175.638934)" fill="#121212" stroke-width="0">
  <tspan y="0" font-weight="400" stroke-width="0">

  </tspan>
</text>
<text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(338.145732 213.7031)" stroke-width="0">
  <tspan y="0" font-weight="400" stroke-width="0">

  </tspan>
</text>
<text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(151.087549 184.339315)" stroke-width="0">
  <tspan font-family="Roboto" font-size="15" font-weight="400" font-style="normal" transform="translate(151.087549 184.339315)" stroke-width="0">

  </tspan>
</text>
<text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(123.898858 181.620446)" stroke-width="0">
  <tspan font-family="Roboto" font-size="15" font-weight="400" font-style="normal" transform="translate(123.898858 181.620446)" stroke-width="0" fill='#fff'>
  EW02
  </tspan>
</text>
<text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(116.286025 193.58347)" stroke-width="0">
  <tspan font-family="Roboto" font-size="15" font-weight="400" font-style="normal" transform="translate(116.286025 193.58347)" stroke-width="0">

  </tspan>
</text>
<text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="translate(263.648722 206.634041)" fill="url(#eKjTk8iYytS14-fill)" stroke="url(#eKjTk8iYytS14-stroke)">
  <tspan x="0" y="15" font-weight="400">

  </tspan>
</text>
<text dx="0" dy="0" font-family="Roboto" font-size="15" font-weight="400" transform="matrix(1.104999 0 0 1.130302 126.350427 172.424077)" fill="#fff" stroke-width="0">
  <tspan y="0" font-weight="400" stroke-width="0">

  </tspan>
</text>
</svg>
);


    case"CR01":
        return(
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
            <path d="M46.6832,258.673v-217.346h206.63361v217.346h-206.63361Zm78.68547-118.84171v-86.07925h-69.6026v86.07925h69.6026ZM238.2733,245.65363v-139.69206h-63.07755v139.69206h63.07755Z" fill={Color} />
            <text x="115.538809" y="176.478857" fill='#ffffff'>CR01</text>
          </svg>

        )
        break;

    case"CR02":
        return(
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
            <path d="M46.6832,258.673v-217.346h206.63361v217.346h-206.63361Zm80.86057-22.59375v-86.07925h-69.6026v86.07925h69.6026Z" fill={Color}/>
            <text x="132.076706" y="146.193583" fontFamily='Roboto' fill="#fffcfc">CR02</text>
          </svg>


        )
        break;
    case"CR04":
        return(
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
              <rect width="48" height="48" rx="0" ry="0" transform="matrix(3.239986 0 0 3.893641 72.240336 65.252997)" fill={Color}/>
              <text x="130.662045" y="163.866231" fontFamily='Roboto' fill="#fff">CR04</text>
            </svg>


        )
        break;

    case"CR03":
    return(
      <svg
    id="eaqJ7dGODAl1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 300"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <defs>
      <radialGradient id="eaqJ7dGODAl4-fill" cx="0" cy="0" r="0.5">
        <stop id="eaqJ7dGODAl4-fill-0" offset="100%" stopColor="#000" />
        <stop id="eaqJ7dGODAl4-fill-1" offset="100%" stopColor="#fff" />
      </radialGradient>
      <linearGradient id="eaqJ7dGODAl4-stroke" x1="0" y1="0.5" x2="1" y2="0.5">
        <stop id="eaqJ7dGODAl4-stroke-0" offset="0%" stopColor="#fff" />
        <stop id="eaqJ7dGODAl4-stroke-1" offset="100%" stopColor="rgba(0,5,5,0)" />
      </linearGradient>
    </defs>

    <text
      dx="0"
      dy="0"
      fontFamily="Roboto"
      fontSize="15"
      fontWeight="400"
      transform="translate(338.145732 213.7031)"
      strokeWidth="0"
    >
      {/* You can add text here if needed */}
    </text>

    <path
      d="M124.98638,238.1728v-175.6388h-.00002v-45.84003l47.8522,26.1345v19.70553h-.00017v175.6388h-47.85201Z"
      transform="matrix(1.795447 0 0-1-117.36443 254.86677)"
      fill={Color} // Example color control
    />

    <text
      dx="0"
      dy="0"
      fontFamily="Roboto"
      fontSize="15"
      fontWeight="400"
      transform="translate(132.523531 132.599236)"
      fill="#fff7f7" // Control text color
      strokeWidth="0"
    >
      CR03
    </text>
  </svg>
    );break
    case "CR04":
      return(
        <svg
    id="e2s47FiPECe1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 300 300"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <defs>
      <radialGradient
        id="e2s47FiPECe3-fill"
        cx="0"
        cy="0"
        r="0.5"
        spreadMethod="pad"
        gradientUnits="objectBoundingBox"
        gradientTransform="translate(0.5 0.5)"
      >
        <stop id="e2s47FiPECe3-fill-0" offset="0%" stopColor="#000" />
        <stop id="e2s47FiPECe3-fill-1" offset="0%" stopColor="#fff" />
      </radialGradient>
    </defs>

    <rect
      width="48"
      height="48"
      rx="0"
      ry="0"
      transform="matrix(3.239986 0 0 3.893641 72.240336 65.252997)"
      fill="#121212"
    />
    <text
      dx="0"
      dy="0"
      fontFamily="Roboto"
      fontSize="15"
      fontWeight="400"
      transform="translate(130.662045 163.866231)"
      fill="url(#e2s47FiPECe3-fill)"
      strokeWidth="0"
    >
      <tspan y="0" fontWeight="400" strokeWidth="0">
        CR04
      </tspan>
    </text>
  </svg>
      );break
}



}
